<template>
  <div class="main">    
    <a-form
      class="user-layout-login"
      ref="formLogin"
      :autoFormCreate="(form)=>{this.form = form}"
      id="formLogin"
    >
      <a-form-item
        fieldDecoratorId="username"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入帐户名' }, { validator: this.handleUsernameOrEmail }], validateTrigger: 'change'}"
      >
        <a-input size="large" type="text" placeholder="帐户名">
          <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>

      <a-form-item
        fieldDecoratorId="password"
        :fieldDecoratorOptions="{rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}"
      >
        <a-input size="large" type="password" autocomplete="false" placeholder="密码">
          <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }"/>
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-checkbox v-model="formLogin.rememberMe">自动登陆</a-checkbox>
      </a-form-item>
      <a-form-item style="margin-top:24px">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loginBtn"
          @click.stop.prevent="handleSubmit"
          :disabled="loginBtn||overDate"
        >确定</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { mapActions,mapState} from 'vuex'
import { timeFix } from '@/utils/util'

export default {
  data() {
    return {
      loginBtn: false,
      switchTenantVisible:false,
      form: null,
      formLogin: {
        username: '',
        password: '',
        rememberMe: true
      }
    }
  },
  computed:{
    ...mapState({tenant:state=>state.session.tenant}),
  },
  created() {
    
  },
  methods: {
    ...mapActions(['Login', 'Logout','initAbp']),
    showTenantSwitch(){
      this.switchTenantVisible=true
    },
    // handler
    handleUsernameOrEmail(rule, value, callback) {
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        this.loginType = 0
      } else {
        this.loginType = 1
      }
      callback()
    },
    handleSubmit() {
      const that = this
      let flag = false

      const loginParams = {
        rememberClient: that.formLogin.rememberMe
      }
      that.form.validateFields(['username', 'password'], { force: true }, (err, values) => {
        if (!err) {
          flag = true
          loginParams.userNameOrEmailAddress = values.username
          loginParams.password = values.password
        }
      })
      if (!flag) return
      that.loginBtn = true
      that
        .Login(loginParams)
        .then(() => {
          that.loginSuccess()
        })
        .catch(() => {
          this.loginBtn = false
        })
    },
    loginSuccess() {
      this.loginBtn = false
      window.location.reload()
      this.initAbp().then(()=>{
        this.$router.push({ name: 'dashboard' })
        this.$notification.success({
          message: '欢迎',
          description: `${timeFix()}，欢迎回来`
        })
      })      
    }
  }
}
</script>

<style lang="scss" scoped>
.user-layout-login {
  label {
    font-size: 14px;
  }
  .overdate-tip{
      color:#f5222d;
      text-align: center
  }
  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }
  .school-switch{
    text-align: center;
    margin-bottom: 20px;
  }
  button.login-button {
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
    
  }
}
</style>